export default __webpack_public_path__ + "static/media/project-logo.e8ddaf1c.png";